import { Typography } from '@mui/material'

export function AsteriskRed() {
  return (
    <Typography component="span" display="inline-block" color="red">
      *
    </Typography>
  )
}
